export const PUBLIC_SITE_NAME = 'Cathie Wood Capital';
export const SIGNED_IN_PRODUCT_NAME = 'CathieForm';
export const WORKSPACE_LABEL = 'My Workspace';
export const ASSISTANT_NAME = 'Ada';
export const ACCENT = '#0F766E';
// Brand image slots: set to '/img/<file>' after uploading assets to frontend/public/img; null falls back to the drawn mark.
export const LOGO_URL = '/img/cwc-logo-t.png';
export const BG_LOGO_URL = '/img/cwc-bg-logo-t.png';
export const SIGNATURE_URL = '/img/cwc-signature-white.png';
export const BG_IMAGE_URL = '/img/cwc-bg.jpg';
